import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';

function initTextImageSlider() {
  $(function () {
    if ($('.slider-block').length <= 0) {
      return;
    }

    $('.text-image-slider').each(function () {
      const block = $(this);
      const sliders = $(this).find('.text-image-slider__wrapper');
      sliders.each(function () {
        const arrows = $(this).find('.slider-arrows');
        const slider = $(this);
        new Swiper(slider.get(0), {
            modules: [Navigation],
            slidesPerView: 1, // Default value for large screens
            spaceBetween: 0,
            loop: false,
            navigation: {
                nextEl: block.find('.swiper-button-next').get(0),
                prevEl: block.find('.swiper-button-prev').get(0),
            },
            watchOverflow: true, // Automatically hide pagination if all slides fit
            breakpoints: {
            576: {
                slidesPerView: 1, // Mobile
            },
            768: {
                slidesPerView: 1, // Tablet
            },
            1024: {
                slidesPerView: 1, // Desktop
            },
            }
        
        });
        });
    });
  });
}

export { initTextImageSlider };
